import * as React from "react";
import { Header, Grid, Segment, Loader } from "semantic-ui-react";

import { useState, useEffect } from "react";

import { CustomerUserStatistics } from "../model";
import { getStatistics } from "../StatisticsApi";

import { OhCasesGraph } from "./OhCasesGraph";
import { ReferralAppointmentTypesStatistics } from "./ReferralAppointmentTypesStatistics";
import { DnasStatistics } from "./DnasStatistics";

export const StatisticsOverview = () => {
    const [statistics, setStatistics] = useState<CustomerUserStatistics>(null);
    useEffect(() => {
        (async () => {
            setStatistics(await getStatistics());
        })();
    }, []);

    if (statistics === null) {
        return <Loader active />;
    }

    return (
        <>
            <Grid>
                <Grid.Row>
                    <Grid.Column computer={12} mobile={16}>
                        <Segment>
                            <Header as="h2">Statistics: {statistics.startDate.format("DD/MM/YYYY")} - {statistics.endDate.format("DD/MM/YYYY")}</Header>
                            <OhCasesGraph monthlyOhCaseCounts={statistics.monthlyOhCaseCounts} />
                        </Segment>
                    </Grid.Column>
                    <Grid.Column computer={4} mobile={16}>
                        <Segment><ReferralAppointmentTypesStatistics appointmentPercentages={statistics.referralAppointmentPercentages} /></Segment>
                        <Segment>
                            <DnasStatistics
                                didNotAttendAppointmentsLast12Months={statistics.didNotAttendAppointmentsLast12Months}
                                didNotAttendAppointmentsMonthToDate={statistics.didNotAttendAppointmentsMonthToDate}
                            />
                        </Segment>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </>
    );
};
